/* ============================================================
   AVANTI - grip finder
   Four steps, one answer per step, result computed locally.
   No network calls, no storage: the answers are only useful for
   the length of the visit, and keeping them in memory avoids
   asking the visitor to think about data they did not offer.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('[data-finder-data]');
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var progress = root.querySelectorAll('[data-finder-progress] li');
    var result = root.querySelector('[data-finder-result]');
    var backBtn = root.querySelector('[data-finder-back]');
    var restartBtn = root.querySelector('[data-finder-restart]');

    var answers = {};
    var current = 0;

    /* Step 5 asks which putter grip, and only makes sense once step 4 says
       a putter is involved. Anyone re-gripping swing clubs skips it, so the
       flow is not a straight run through every fieldset. */
    function wantsPutter() {
      return answers.clubs === 'putter' || answers.clubs === 'both';
    }
    function isSkipped(i) {
      return steps[i].hasAttribute('data-step-putter') && !wantsPutter();
    }
    function nextIndex(from) {
      for (var i = from + 1; i < steps.length; i++) { if (!isSkipped(i)) return i; }
      return -1;
    }
    function prevIndex(from) {
      for (var i = from - 1; i >= 0; i--) { if (!isSkipped(i)) return i; }
      return -1;
    }

    function show(i) {
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      for (var p = 0; p < progress.length; p++) {
        progress[p].hidden = isSkipped(p);
        progress[p].classList.toggle('is-active', p <= i);
      }
      current = i;
      if (backBtn) backBtn.hidden = i === 0;
      if (result) result.hidden = true;
      steps.forEach(function (s, n) { s.hidden = false; });
    }

    /* Which model fits. Weather decides first because a corded grip in
       the wet is a functional requirement, not a preference; feel only
       breaks the tie when conditions leave it open. */
    function pick() {
      if (wantsPutter() && answers.putter) return 'putter_' + answers.putter;
      if (answers.clubs === 'putter') return 'putter_pistol';

      if (answers.weather === 'wet') return 'cord';
      if (answers.weather === 'mixed') return 'hybrid';

      // dry
      if (answers.feel === 'firm') return 'cord';
      if (answers.feel === 'both') return 'hybrid';
      return 'rubber';
    }

    /* Fall back through the range rather than showing an empty card if
       a product slot has been left unset in the theme editor. */
    function resolve(key) {
      var order = key.indexOf('putter') === 0
        ? [key, 'putter_pistol', 'putter_rubber', 'putter_xl']
        : [key, 'hybrid', 'rubber', 'cord'];
      for (var i = 0; i < order.length; i++) {
        if (DATA.urls[order[i]]) return order[i];
      }
      return null;
    }

    function finish() {
      var key = resolve(pick());
      if (!key || !result) return;

      var name = root.querySelector('[data-result-name]');
      var size = root.querySelector('[data-result-size]');
      var why = root.querySelector('[data-result-why]');
      var link = root.querySelector('[data-result-link]');

      if (name) name.textContent = DATA.labels[key] || '';
      if (why) why.textContent = DATA.why[key] || '';
      if (link) link.setAttribute('href', DATA.urls[key] || '#');
      if (size) {
        size.textContent = key.indexOf('putter') === 0
          ? '\u2014'
          : (DATA.sizes[answers.size] || DATA.sizes.standard || '');
      }

      steps.forEach(function (s) { s.classList.remove('is-active'); s.hidden = true; });
      result.hidden = false;
      for (var p = 0; p < progress.length; p++) progress[p].classList.add('is-active');
      if (backBtn) backBtn.hidden = false;
      result.setAttribute('tabindex', '-1');
      result.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-key]');
      if (opt && root.contains(opt)) {
        answers[opt.getAttribute('data-key')] = opt.getAttribute('data-value');

        var step = opt.closest('[data-step]');
        if (step) {
          step.querySelectorAll('[data-key]').forEach(function (b) {
            b.classList.toggle('is-selected', b === opt);
            b.setAttribute('aria-pressed', b === opt ? 'true' : 'false');
          });
        }

        var next = nextIndex(current);
        if (next === -1) finish(); else show(next);
        return;
      }

      if (e.target.closest('[data-finder-back]')) {
        if (result && !result.hidden) {
          var last = prevIndex(steps.length);
          if (last !== -1) show(last);
        } else {
          var prev = prevIndex(current);
          if (prev !== -1) show(prev);
        }
        return;
      }

      if (e.target.closest('[data-finder-restart]')) {
        answers = {};
        root.querySelectorAll('[data-key]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        show(0);
      }
    });

    show(0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-avanti-finder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // the theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
